import React from 'react';
import PropTypes from 'prop-types';
import { useDividerGradient } from '../gradient-utils';

export function WaveSmooth({
  className,
  amplitude = 50,
  fadeOpacity,
  fadeDirection,
  softness,
  style
}) {
  const { defs, fill, mask } = useDividerGradient({ fadeOpacity, fadeDirection, softness });

  // amplitude 0 = flat, amplitude 100 = full wave height
  const waveHeight = (amplitude / 100) * 60;
  const mid = 60;
  const top = mid - waveHeight;
  const bottom = mid + waveHeight;

  return (
    <svg
      className={ className }
      style={ style }
      viewBox='0 0 1200 120'
      preserveAspectRatio='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      { defs }
      <path
        d={ `M0,${mid} C200,${bottom} 400,${top} 600,${mid} C800,${bottom} 1000,${top} 1200,${mid} L1200,120 L0,120 Z` }
        fill={ fill }
        mask={ mask }
      />
    </svg>
  );
}

WaveSmooth.propTypes = {
  className: PropTypes.string,
  amplitude: PropTypes.number,
  fadeOpacity: PropTypes.number,
  fadeDirection: PropTypes.oneOf(['down', 'up', 'left', 'right']),
  softness: PropTypes.number
};
